import React, { useState } from 'react';
import './Home.css';
import Notification from './Notification';

function Constitution() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="home">
      {/* Header */}
      <header className="top-header">
        <div className="header-inner">
          <div className="header-logos">
            <a href="/" aria-label="Go to home page">
              <img src="img/nrb.png" alt="Logo 1" className="header-logo-img" />
            </a>
            <a href="https://ayush.gov.in/" target="_blank" rel="noopener noreferrer" aria-label="Open Ministry of Ayush website">
              <img src="img/MOA.png" alt="Logo 2" className="header-logo-img" />
            </a>
          </div>

          <div className="topbar-marquee-group">
            <Notification />
            <Notification
              variant="danger"
              messages={[
                'State registration is mandatory as part of the NRB-HPR integrated registration process. Kindly download the HPR Certificate and I-card from HPR Portal through this link https://nhpr.abdm.gov.in/nhpr/v4/login'
              ]}
            />
          </div>
        </div>
      </header>

      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-inner">
          <button
            className="nav-toggle"
            aria-label="Toggle navigation"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
          </button>
          <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
            <li><a href="/">Home</a></li>
            <li className="nav-dropdown">
              <a href="#about">About</a>
              <ul className="dropdown-menu">
                <li><a href="/about-us">About NRB</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/" target="_blank" rel="noopener noreferrer">About NIN</a></li>
              </ul>
            </li>
            <li><a href="/constitution">Constitution of NRB</a></li>
            <li className="nav-dropdown">
              <a href="#directory">NRB Directory</a>
              <ul className="dropdown-menu">
                <li><a href="/doctors-list">List of Doctors Registered</a></li>
                <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#events">Events</a>
              <ul className="dropdown-menu">
                <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
                <li><a href="/gallery">News & Events</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#resources">Resources</a>
              <ul className="dropdown-menu">
                <li><a href="/state-boards">State Registration Board</a></li>
                <li><a href="/medical-colleges">State Wise Yoga & Naturopathy Medical Colleges in India, 2023</a></li>
                <li><a href="/who-naturopathic-workforce">World Health Organisation (WHO) Region wise listing of countries with Naturopathic Workforce 2023</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#others">Others</a>
              <ul className="dropdown-menu">
                <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/nisargopcharVartaArchive" target="_blank" rel="noopener noreferrer">Nisargopchar Varta</a></li>
              </ul>
            </li>
            <li><a href="/contact">Contact</a></li>
            <li className="nav-cta-mobile"><a href="https://app.nrb.net.in/#/session/signin/step1">Register</a></li>
          </ul>
          <a href="https://app.nrb.net.in/#/session/signin/step1" className="nav-cta">Click here to Register</a>
        </div>
      </nav>

    <div className="constitution-page">
      <div className="constitution-hero">
        <h1 className="constitution-main-heading">Constitution of Naturopathy Registration Board</h1>
        <p className="constitution-subtitle">Official composition and governance structure as per Ministry of AYUSH, Government of India</p>
      </div>

      <div className="content-wrapper">
        <h2 className="section-heading-large">Board Composition</h2>
        <div className="constitution-table-wrap">
          <table className="constitution-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>PARTICULARS</th>
                <th>CHAIRMAN/MEMBERS</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1.</td>
                <td>Secretary, Ministry of Ayush</td>
                <td>Chairperson</td>
              </tr>
              <tr>
                <td>2.</td>
                <td>Joint Secretary, In-charge of Yoga Naturopathy Cell, Ministry of Ayush</td>
                <td>Vice-Chairperson</td>
              </tr>
              <tr>
                <td>3.</td>
                <td>Special Secretary &amp; FA, Ministry of Health &amp; F.W., Govt. of India or his/her representative not below the rank of Under Secretary</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>4.</td>
                <td>Shri Shamsher Singh, Senior Legal Counsel/Legal Counsel (Legal Expert)</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>5.</td>
                <td>Shri Anil Jauhri (Accreditation Expert)</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>6.</td>
                <td>Dr. Vimal Kumar Modi, Director, Arogya Mandir, Medical College Road, Gorakhpur, Uttar Pradesh - 273003</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>7.</td>
                <td>Dr. N.K. Manjunath, Vice Chancellor, SVYASA University, 19, Eknath Bhavan, Bengaluru, Karnataka - 560019</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>8.</td>
                <td>Dr. M.V. Mallikarjun, Principal, Gandhi Naturopathic Medical College, Dharam Karam Road, Ameerpet, Hyderabad - 500 016</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>9.</td>
                <td>Dr. Bharat Shah, Director, Nisargopachar Kendra, Vinoba Ashram, Gotri, Vadodara, Gujarat - 390021</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>10.</td>
                <td>Advisor, Y&amp;N, Ayush</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>11.</td>
                <td>Director, National Institute of Naturopathy</td>
                <td>CEO / Member Secretary</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="committees-intro-card">
          <h2 className="committees-heading">Committees</h2>
          <div className="committees-note">
          <p>The board consists of three committees to advise the board on policy matters, academic, accreditation, evaluation and certification of Naturopathy professionals, paramedicals, health promoters and Naturopathy institutions.</p>
          <ol className="committees-list">
            <li>Steering Committee</li>
            <li>Technical Committee</li>
            <li>Registration Committee</li>
          </ol>
          </div>
        </div>

        <div className="committee-section-card">
          <h3 className="committee-section-heading">MEMBERS OF STEERING COMMITTEE</h3>
          <div className="committee-table-wrap">
            <table className="committee-table">
              <thead>
                <tr>
                  <th>S.NO</th>
                  <th>Name</th>
                  <th>Address</th>
                  <th>Occupation</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Dr. Vimal Kumar Modi</td>
                  <td>Director, Arogya Mandir, Medical College Road, Gorakhpur, Uttar Pradesh - 273003</td>
                  <td>Chairperson</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Dr. N.K. Manjunath</td>
                  <td>Vice Chancellor, SVYASA University, 19, Eknath Bhavan, Bengaluru, Karnataka - 560019</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Dr. Mallikarjun</td>
                  <td>Principal, Gandhi Naturopathic Medical College,<br/>Dharam Karam Road, Ameerpet, Hyderabad - 500016</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Dr. Bharat Shah</td>
                  <td>Director, Nisargopachar Kendra, Vinoba Ashram, Gotri, Vadodara, Gujarat - 390021</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>Dr. Toran Singh</td>
                  <td>Dean, Faculty of Naturopathy and Yogic Science,<br/>University of Patanjali, Aurangabad, Haridwar,<br/>Uttarakhand - 249402</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>Dr. Hariganesh</td>
                  <td>Resident Medical Officer, Govt. Nature Cure &amp; Yoga Medical College &amp; Teaching Hospital,<br/>Brindavan Extension, K R S Road, Mysore - 570020</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>Dr. Prashanth Shetty</td>
                  <td>Principal, S.D.M. College of Naturopathy &amp; Yogic Sciences,<br/>Dharmasthala Road, Ujire, Karnataka - 574240</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>Prof. Vaidya Arpan Bhatt</td>
                  <td>Prof. &amp; HOD, Department of Swasthavritta &amp; Yoga,<br/>Institute Of Teaching and Research in Ayurveda,<br/>Opp. B-Division Police Station, Gurudwara Road,<br/>Jamnagar, Gujarat - 361008</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>Mr Anant Biradar</td>
                  <td>Vice-Chairman, Surya Foundation, B-3/330, Paschim Vihar, New Delhi - 110063</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>Prof. (Dr.) Geetha B. Shetty</td>
                  <td>Director (Incharge), NIN, Pune</td>
                  <td>CEO &amp; Member Secretary</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h4 className="functions-heading">Functions of the Steering Committee</h4>
          <ul className="functions-list">
            <li>The Steering Committee will advise the Board on policy matters regarding planning, organizing, execution, assessment, monitory controls, and implementation of the Scheme.</li>
            <li>The Steering Committee shall give expert advice with regard to development and evaluation strategies for the Scheme of Naturopathy Certification and Registration of Naturopathy Professionals and Accreditation of Naturopathy Institutions;</li>
            <li>To advise in identifying the priorities and potential risks in the Scheme;</li>
            <li>To advise in maintaining the quality of the Scheme as it develops;</li>
            <li>Providing advice about changes to the Scheme as it develops.</li>
          </ul>
        </div>

        <div className="committee-section-card">
          <h3 className="committee-section-heading">MEMBERS OF TECHNICAL COMMITTEE</h3>
          <div className="committee-table-wrap">
            <table className="committee-table">
              <thead>
                <tr>
                  <th>S.NO</th>
                  <th>Name</th>
                  <th>Address</th>
                  <th>Occupation</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Dr. M. Neeraja Reddy</td>
                  <td>Former Superintendent &amp; Principal Gandhi Naturopathic Medical College<br/>Former Secretary Telangana Yogadityana Parishad<br/>Hyderabad 2-17-8/B A4 SR Heights, Dharma Puri Colony, Uppal, Hyderabad 5000039</td>
                  <td>Chairperson</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Dr. Prashanth Shetty</td>
                  <td>Principal, S.D.M. College of Naturopathy &amp; Yogic Sciences, Dharmasthala Road, Ujire, Karnataka - 574240</td>
                  <td>Vice-Chairperson</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Sh Vikram Singh</td>
                  <td>Admin Expert</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Dr. Abhishek Devikar</td>
                  <td>Director, Nisargopachar Ashram, Uruli Kanchan, Pune – 412202, Maharashtra</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>Dr. Shaiju K. S.</td>
                  <td>District Programme Manager (Trivandrum &amp; Kollam Districts) National AYUSH Mission 5th Floor, Arogya Bhavan<br/>Thiruvananthapuram – 695001 Kerala State</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>Dr. Jitendra Arya</td>
                  <td>Director, Dr. Arya's Nature Cure &amp; Yoga Clinic<br/>D-439, Clover Center, 4th floor, 7, Moledina Road, Pune – 411 001</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>Prof. (Dr.) Geetha B. Shetty</td>
                  <td>Director (Incharge), NIN, Pune</td>
                  <td>CEO &amp; Member Secretary</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h4 className="functions-heading">Functions of the Technical Committee</h4>
          <ul className="functions-list">
            <li>To advise relating to academic, accreditation, and certification matters</li>
            <li>To give technical advice relating to the academic syllabi/courses for various levels;</li>
            <li>To advise the Board norms/criteria for accreditation of the Naturopathy institutes/Centers;</li>
            <li>To advise for modification or upgrading the existing syllabi/courses and accreditation;</li>
            <li>To advise certification process;</li>
            <li>To advise for fixation of fees for Enrolment/registration/certification/accreditation</li>
            <li>To advise for amendment or repeal of the Accreditation processes/prescribed syllabi.</li>
            <li>To advise for the adoption of norms for carrying out the visit and review process for accreditation or revalidation of Naturopathy institutes.</li>
          </ul>
        </div>

        <div className="committee-section-card">
          <h3 className="committee-section-heading">MEMBERS OF REGISTRATION COMMITTEE</h3>
          <div className="committee-table-wrap">
            <table className="committee-table">
              <thead>
                <tr>
                  <th>S.NO</th>
                  <th>Name</th>
                  <th>Address</th>
                  <th>Occupation</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Dr. Babu Joseph</td>
                  <td>Director, Netaji Institute of Nature Cure &amp; Yoga, Kunnumpuram, Kakkanad, Kochi, Kerala – 682030</td>
                  <td>Chairperson</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Dr. Ankesh Singh Bhadoria</td>
                  <td>Principal, SwasthyaKalyan Institute of Naturopathy and Yogic Sciences, LalKothi, Tonk Road, Jaipur, Rajasthan - 302004</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Dr. Saranyan Palanichamy</td>
                  <td>Medical Superintendent, RK Nature Cure Home, No 12 Krishna Layout, Ganapathy, Behind Roots Group of Companies, Coimbatore - 641006</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Dr. D.N. Sharma</td>
                  <td>B-92, Ground floor II, Ram Prastha Colony, Opp. Vivek Vihar, Ghaziabad (Uttar Pradesh)</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>Prof. (Dr.) Geetha B. Shetty</td>
                  <td>Director (Incharge), NIN, Pune</td>
                  <td>CEO &amp; Member Secretary</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h4 className="functions-heading">Functions of the Registration Committee</h4>
          <ul className="functions-list">
            <li>To advise relating to the evaluation and examinations for Certification of Naturopathy Professionals, Naturopathy Health Educators, Health Promoters and assessment of the Naturopathy Institutions;</li>
            <li>To advise for setting up norms for conducting exams and the procedure to be adopted for conducting the exams;</li>
            <li>To advise for setting up principles and guidelines for evaluation of Certification examinations and assessment of the Naturopathy Institutions;</li>
            <li>To advise for modification of existing evaluation and assessment process;</li>
            <li>To advise for need on specific grounds to modify the existing syllabus (for further review by the Technical Committee) and examination procedures;</li>
            <li>To advise suitable person or team of such persons for carrying out the examination / evaluation / assessment;</li>
            <li>To advise for devising procedure, forms of applications for individuals/institutes under the Scheme.</li>
          </ul>
        </div>

        <div className="committee-section-card">
          <h3 className="committee-section-heading">Non official Members</h3>
          <div className="committee-table-wrap">
            <table className="committee-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Name</th>
                  <th>Address</th>
                  <th>Chairman/Member</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1.</td>
                  <td>Dr. Vimal Kumar Modi</td>
                  <td>Director, Arogya Mandir, Medical College Road, Gorakhpur, Uttar Pradesh - 273003</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>2.</td>
                  <td>Dr. N.K. Manjunath</td>
                  <td>Chancellor &amp; Director, Research, SVYASA University, 19, Eknath Bhavan, Bengaluru, Karnataka - 560019</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>3.</td>
                  <td>Dr. MV Mallikarjun</td>
                  <td>Principal, Gandhi Naturopathic Medical College, Dharam Karam Road, Ameerpet, Hyderabad - 500 016</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>4.</td>
                  <td>Dr. Bharat Shah</td>
                  <td>Director, Nisargopachar Kendra, Vinoba Ashram, Gotri, Vadodara, Gujarat - 390021</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>5.</td>
                  <td>Shri Shamsher Singh<br/>(Legal Expert)</td>
                  <td>Ministry of Ayush</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>6.</td>
                  <td>Shri Anil Jauhri<br/>(Accreditation Expert)</td>
                  <td>Ex-CEO, National Accreditation Board for Certification Bodies (NABCB), 485, Pocket C, Sarita Vihar, New Delhi - 110076, India</td>
                  <td>Member</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3 className="footer-heading">Naturopathy Registration Board</h3>
            <p className="footer-desc">
              Regulating and promoting excellence in Naturopathy education and practice across India.
            </p>
            <div className="footer-logos">
              <img src="img/nrb.png" alt="NRB Logo" className="footer-logo" />
              <img src="img/MOA.png" alt="Ministry Logo" className="footer-logo" />
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about-us">About NRB</a></li>
              <li><a href="/constitution">Constitution of NRB</a></li>
              <li><a href="/doctors-list">List of Doctors Registered</a></li>
              <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Important Links</h4>
            <ul className="footer-links">
              <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
              <li><a href="/gallery">News &amp; Events</a></li>
              <li><a href="/state-boards">State Registration Board</a></li>
              <li><a href="/medical-colleges">Medical Colleges</a></li>
              <li><a href="/who-naturopathic-workforce">WHO Naturopathic Workforce</a></li>
              <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact Information</h4>
            <div className="footer-contact">
              <p>Dr Kajal Gupta (Domain Expert), NRB</p>
              <p>📧 nrb@bharatmail.co.in</p>
              <p>📞 86258 33306</p>
              <p>🕐 Mon-Fri: 10:00 AM - 6:00 PM</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Naturopathy Registration Board. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#privacy">Privacy Policy</a>
            <span>|</span>
            <a href="#terms">Terms & Conditions</a>
            <span>|</span>
            <a href="#sitemap">Sitemap</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Constitution;


